import axios from "axios";

// create an axios instance
const service = axios.create({
  // dev 走 devServer 代理，生产走 nginx 反向代理，都用相对路径避免跨域
  baseURL: "", // url = base url + request url
  timeout: 20000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers.accessid = "L00861243";
    config.headers.accesskey = "GVWG0BUR6X-BGX-KBMKWP6K4R3ATJ0BPVRD6PERW";
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log(res);
    if (res instanceof Blob) {
      return response;
    }
    if (res.status !== "100") {
      return Promise.reject(res.data.err_msg);
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  },
);

export default service;
